import React, { useCallback, useEffect, useRef, useState } from "react";
import "./pausescreen.css";
import useNavigation from "../../hooks/useNavigation";
import useTextFadeSwitcher from "../../hooks/useTextFadeSwitcher";
import { animated, useTransition } from "react-spring";
import useIsPc from "../../hooks/useIsPc";
import { useLayoutContext } from "../../layout/layout-provider";
import { useScribeContext } from "contexts/scribe/scribe-provider";
import CircularTimer from "./CircularTimer";

const Pausepage: React.FC = () => {
  const inactivityTimerRef = useRef<NodeJS.Timeout | null>(null);
  const secondTimerRef = useRef<NodeJS.Timeout | null>(null);
  const { isPaused, setIsPaused, reset: resetLayout } = useLayoutContext();
  const { reset: resetScribe } = useScribeContext();
  const { navigateToScreensaver, isScreensaverActive } = useNavigation();
  const isPc = useIsPc();

  const {
    text: textTitle,
    fadeProps: fadePropsTitle,
    textStyle: titleStyle,
  } = useTextFadeSwitcher(
    "SEI ANCORA QUI?",
    "ARE YOU STILL HERE?",
    3000,
    "40px",
    "0.1",
  );

  const {
    text: textSub,
    fadeProps: fadePropsSub,
    textStyle: subStyle,
  } = useTextFadeSwitcher(
    "TOCCA UN PUNTO QUALSIASI PER CONTINUARE",
    "TOUCH ANY POINT TO CONTINUE",
    3000,
    "25px",
      "0.1",
  );

  const transitions = useTransition(isPaused, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 500 }, // Adjust duration as needed
  });

  //TODO: i need to manage user inactivity. if after 10 seconds of inactivity: start a second timer of 15. if the user interacts (click the div and call handleClick), cancel and restart timer.

  const resetTimers = useCallback(() => {
    if (inactivityTimerRef.current) {
      clearTimeout(inactivityTimerRef.current);
    }
    if (secondTimerRef.current) {
      clearTimeout(secondTimerRef.current);
    }

    inactivityTimerRef.current = setTimeout(() => {
      // Actions after 10 seconds of inactivity
      setIsPaused(true); // Example action
      secondTimerRef.current = setTimeout(() => {
        // Actions after additional 15 seconds
        setIsPaused(false);
        resetLayout();
        resetScribe();
        navigateToScreensaver();
        // Add other actions if needed
      }, 45000);
    }, 30000);
  }, []);

  useEffect(() => {
    if (isScreensaverActive()) return;
    resetTimers();

    // Add event listeners for user activity
    document.addEventListener("click", resetTimers);
    document.addEventListener("mousemove", resetTimers);
    // Add other event listeners as needed

    return () => {
      // Cleanup
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
      if (secondTimerRef.current) {
        clearTimeout(secondTimerRef.current);
      }
      document.removeEventListener("click", resetTimers);
      document.removeEventListener("mousemove", resetTimers);
      // Remove other event listeners as added
    };
  }, [resetTimers]);

  const handleClick = () => {
    setIsPaused(false);
  };

  return (
    <>
      {!isScreensaverActive() &&
        isPc &&
        transitions(
          (styles, item) =>
            item && (
              <animated.div
                style={styles}
                className={isPc ? "PauseScreen" : "PauseScreenMobile"}
                onClick={handleClick}
              >
                <div>
                  <animated.h1
                    style={{
                      ...fadePropsTitle,
                      ...titleStyle,
                      color: "#AD8B19",
                      fontWeight: "bold",

                    }}
                  >
                    {textTitle}
                  </animated.h1>
                  <animated.h1
                    style={{
                      ...fadePropsSub,
                      ...subStyle,
                    }}
                  >
                    {textSub}
                  </animated.h1>

                <CircularTimer duration={45}/>
                </div>
              </animated.div>
            ),
        )}
    </>
  );
};

export default Pausepage;
